import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { DemoProvider } from "@/context/DemoContext";
import { useReducedMotion } from "@/hooks/useReducedMotion";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";

import { Nav } from "@/components/Nav";
import { DemoModal } from "@/components/DemoModal";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/Hero";
import { SceneWhy } from "@/sections/SceneWhy";
import { SceneDeliveries } from "@/sections/SceneDeliveries";
import { SceneComplexity } from "@/sections/SceneComplexity";
import { SceneOneAction } from "@/sections/SceneOneAction";
import { SceneConnects } from "@/sections/SceneConnects";
import { SceneService } from "@/sections/SceneService";
import { SceneClose } from "@/sections/SceneClose";
import { FeaturesSection } from "@/sections/FeaturesSection";
import { FinalCTA } from "@/sections/FinalCTA";
import { PrivacyPolicy } from "@/pages/PrivacyPolicy";
import { TermsOfService } from "@/pages/TermsOfService";
import { Support } from "@/pages/Support";
import { Contact } from "@/pages/Contact";
import { CookiePolicy } from "@/pages/CookiePolicy";
import { DataProcessingAgreement } from "@/pages/DataProcessingAgreement";
import { ServiceLevelAgreement } from "@/pages/ServiceLevelAgreement";
import MasterServiceAgreement from "@/pages/MasterServiceAgreement";

function Landing() {
  const reduced = useReducedMotion();
  useSmoothScroll(reduced);

  return (
    <div className="App relative bg-[#f5f2ea]">
      <div className="mo-grain" aria-hidden="true" />
      <Nav />

      <main>
        <Hero />
        <SceneWhy />
        <SceneDeliveries />
        <SceneComplexity />
        <SceneOneAction />
        <SceneConnects />
        <SceneService />
        <SceneClose />
        <FeaturesSection />
        <FinalCTA />
      </main>

      <Footer />
    </div>
  );
}

function App() {
  return (
    <DemoProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/dpa" element={<DataProcessingAgreement />} />
          <Route path="/sla" element={<ServiceLevelAgreement />} />
          <Route path="/master-service-agreement" element={<MasterServiceAgreement />} />
          <Route path="/support" element={<Support />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </BrowserRouter>
      <DemoModal />
      <Toaster
        position="bottom-center"
        theme="light"
        toastOptions={{
          style: {
            background: "#ffffff",
            border: "1px solid rgba(27,26,24,0.1)",
            color: "#1b1a18",
          },
        }}
      />
    </DemoProvider>
  );
}

export default App;
